import { defaultParamList } from '@helpers/constant';
import React, { Fragment, useEffect, useState } from 'react';
import useAction from '../hooks/useAction';
import useActionTopics from "@pages/topics/hooks/useAction";
import Filter from './filter';
import Table from './table';

export default function (props: any) {
  const { data, getData, metaData, isLoader, deleteData } = useAction();
  const { getData: getTopics, isLoader: isLoaderListTopic, data: dataListTopic } = useActionTopics();
  const [params, setParams]: any = useState(defaultParamList);
  useEffect(() => {
    fetchMaster();
    fetchData();
  }, []);

  const fetchData = async (newParams?: any) => {
    const param = {
      ...params,
      ...newParams
    };
    await setParams(param);
    getData(param);

  };

  const fetchMaster = () => {
    getTopics({ page: 1, limit: 10, all: true });
  }

  const onSearch = (query: string) => {
    const param = Object.assign({ page: 1, query });
    fetchData(param)
  }

  const onChangeTopic = (topic: string) => {
    const param = Object.assign({ page: 1, topic });
    fetchData(param)
  }

  const onChangeStatus = (status: string) => {
    const param = Object.assign({ page: 1, status });
    fetchData(param)
  }

  const onChangeDateRange = (dateRange: string) => {
    const param = Object.assign({ page: 1, publishedAt: dateRange });
    fetchData(param)
  }

  const onHandleTableChange = (pagination: any, filters: any, sorter: any) => {
    const { current, pageSize } = pagination;
    const sort = sorter.columnKey ? sorter.order : 'desc';
    const orderBy = sorter.columnKey ? sorter.columnKey : 'updatedAt';

    const param = {
      ...params,
      limit: pageSize,
      orderBy,
      page: pageSize == params.limit ? current : 1,
      sort: sort,
    };
    fetchData(param);
  }

  return (
    <Fragment>
      <Filter
        {...props}
        dataSource={data}
        onSearch={onSearch}
        onChangeTopic={onChangeTopic}
        isLoaderListTopic={isLoaderListTopic}
        dataListTopic={dataListTopic}
        onChangeStatus={onChangeStatus}
        onChangeDateRange={onChangeDateRange}
      />
      <Table
        {...props}
        fetchDataList={fetchData}
        loading={isLoader}
        dataSource={data}
        metaData={metaData}
        deleteData={deleteData}
        onTableChange={onHandleTableChange} />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/landing-page/libraries/index.tsx